import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom';
import Scrumboard from './scrumboard';

const Project = ({ match }) => {
	return (
		<Switch>
			<Redirect exact from={`${match.url}`} to={`${match.url}/scrumboard`} />
			<Route path={`${match.url}/scrumboard`} component={Scrumboard} />
		</Switch>
	)
}

export default Project
